import React, { useState } from "react";

import LeftPanel from "../LeftPanel/LeftPanel";
import CommandPalette from "../CommandPalette/CommandPalette";
import SVGLayer from "./SVGLayer/SVGLayer";

import "../Workspace/Workspace.css"

const Workspace = () => {

    // state variables
    var [isDragging, setIsDragging] = useState(false);
    var [top, setTop] = useState(0)
    var [left, setLeft] = useState(0)
    var [computedStyles, setComputedStyles] = useState(null);
    var [cp, setCp] = useState(document.getElementById("command-palette"));
    
    // mousemove event handler for when the command palette is being moved
    function movePalette(e){
        // if an object is being dragged (mousedown registered)
        if (isDragging){

            // then change the object's position
            cp.style.top = (e.clientY - top) + "px";
            cp.style.left = (e.clientX - left) + "px";

        }
    }

    return (
        // workspace with the left panel and command palette
        <div id="workspace" onMouseMove={(e) => movePalette(e)}>
           <LeftPanel />
           <SVGLayer />
           <CommandPalette
             // transfer state
             isDragging={isDragging}
             setIsDragging={setIsDragging}
             top={top}
             setTop={setTop}
             left={left}
             setLeft={setLeft}
             computedStyles={computedStyles}
             setComputedStyles={setComputedStyles}
             cp={cp}
             setCp={setCp}/>
        </div>
    )

}

export default Workspace;